module.exports = __webpack_public_path__ + "static/media/abt-3.4dfa7284.png";